// action types
import { createRequestTypes } from "../../utils";

export const FETCH_GLOBAL_STATS = createRequestTypes("FETCH_GLOBAL_STATS");

export const fetchGlobalStatsRequest = () =>
    ({ type: FETCH_GLOBAL_STATS.REQUEST });

export const fetchGlobalStatsSuccess = (stats) =>
    ({ type: FETCH_GLOBAL_STATS.SUCCESS, payload: { stats } });

export const fetchGlobalStatsFailure = (error) =>
    ({ type: FETCH_GLOBAL_STATS.FAILURE, payload: { error } });
